import { Scissors, Sparkles, Heart } from 'lucide-react';
import { ExclusiveOffers } from '@/components/ExclusiveOffers';

export default function Services() {
  const serviceCategories = [
    {
      title: "Men's Grooming",
      icon: Scissors,
      image: "https://images.unsplash.com/photo-1532710093739-9470acff878f?crop=entropy&cs=srgb&fm=jpg&q=85",
      services: [
        { name: "Hair Cut", price: "₹100" },
        { name: "Shave", price: "₹60" },
        { name: "Hair Wash", price: "₹100" },
        { name: "Head Massage", price: "₹150" },
        { name: "Hair Spa", price: "₹440" }
      ]
    },
    {
      title: "Women's Hair",
      icon: Sparkles,
      image: "https://images.unsplash.com/photo-1733995471058-3d6ff2013de3?crop=entropy&cs=srgb&fm=jpg&q=85",
      services: [
        { name: "Hair Cut", price: "₹199" },
        { name: "Hair Wash", price: "₹150" },
        { name: "Blow Dry", price: "₹250" },
        { name: "Iron Flat", price: "₹400" },
        { name: "Tongs / Curls", price: "₹500" },
        { name: "Keratin Treatment", price: "₹1999", special: true }
      ]
    },
    {
      title: "Skin & Beauty",
      icon: Heart,
      image: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&q=85",
      services: [
        { name: "Threading (Eyebrows)", price: "₹30" },
        { name: "Fruit Facial", price: "₹800" },
        { name: "Clean Up (Fruit)", price: "₹550" },
        { name: "D-Tan", price: "₹500" },
        { name: "Waxing (Full Hands)", price: "₹200" },
        { name: "Waxing (Full Legs)", price: "₹350" }
      ]
    },
    {
      title: "Hands & Feet",
      icon: Sparkles,
      image: "https://images.unsplash.com/photo-1665960211264-5e0a7112bacd?crop=entropy&cs=srgb&fm=jpg&q=85",
      services: [
        { name: "Manicure", price: "₹430" },
        { name: "Pedicure", price: "₹550" },
        { name: "Spa Pedicure", price: "₹950" }
      ]
    }
  ];

  const handleBooking = () => {
    const message = encodeURIComponent("Hi, I'd like to book an appointment at Magic Touch Salon.");
    window.open(`https://wa.me/919870214490?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white">
            Our <span className="text-[#D4AF37]">Services</span>
          </h1>
          <p className="text-lg text-[#A3A3A3] max-w-2xl mx-auto">
            Premium grooming and beauty services tailored to perfection
          </p>
        </div>

        <div className="space-y-16">
          {serviceCategories.map((category, index) => {
            const Icon = category.icon;
            return (
              <div
                key={index}
                data-testid={`service-category-${category.title.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}`}
                className="bg-neutral-900/50 border border-neutral-800 overflow-hidden hover:border-[#D4AF37]/50 transition-colors duration-300"
              >
                <div className="grid md:grid-cols-2 gap-0">
                  <div
                    className="h-64 md:h-auto bg-cover bg-center relative"
                    style={{ backgroundImage: `url(${category.image})` }}
                  >
                    <div className="absolute inset-0 bg-black/40"></div>
                  </div>
                  <div className="p-8 md:p-12">
                    <div className="flex items-center space-x-4 mb-6">
                      <Icon className="text-[#D4AF37]" size={40} />
                      <h2 className="text-3xl sm:text-4xl font-bold text-white">
                        {category.title}
                      </h2>
                    </div>
                    <div className="space-y-4">
                      {category.services.map((service, idx) => (
                        <div
                          key={idx}
                          className="flex justify-between items-center py-3 border-b border-neutral-800 last:border-0"
                        >
                          <span className="text-white text-lg">
                            {service.name}
                            {service.special && (
                              <span className="ml-2 text-xs bg-red-600 text-white px-2 py-1 uppercase font-bold">
                                Special Price
                              </span>
                            )}
                          </span>
                          <span className="text-[#D4AF37] text-lg font-semibold">{service.price}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Exclusive Offers Section */}
        <div className="my-20">
          <ExclusiveOffers />
        </div>

        <div className="mt-16 text-center">
          <p className="text-[#A3A3A3] mb-6">
            All prices are exclusive of taxes. Prices may vary based on hair length and service complexity.
          </p>
          <button
            data-testid="services-book-btn"
            onClick={handleBooking}
            className="bg-[#D4AF37] text-black font-semibold px-12 py-4 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300 gold-glow"
          >
            Book Your Service
          </button>
        </div>
      </div>
    </div>
  );
}
